<template>
  <div
    class="rounded-full px-1 py-1 cursor-pointer text-white font-normal bg-blue-300 flex text-xs mr-1 mt-0"
    data-test-id="Tag"
    @click="$emit('click', $event)"
  >
    {{ tagName }}
    <div class="rounded-full bg-blue-500 px-1 ml-1 ">
      <font-awesome-icon
        v-if="deletable"
        class="text-xs m-auto"
        :icon="['fal', 'times']"
        @click.stop="$emit('remove')"
      />
      <font-awesome-icon
        v-else
        class="text-xs"
        :icon="['fal', 'plus']"
        @click.stop="$emit('click', $event)"
      />
    </div>
  </div>
</template>

<script>
/* build the current page */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes, faPlus } from '@fortawesome/pro-light-svg-icons'
library.add(faTimes, faPlus)
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    tagName: { type: String, default: null },
    deletable: { type: Boolean, default: true }
  }
}
</script>
